import React from 'react';
import * as breadcrumbStyle from './newBreadcrumbs.module.scss';
import { Link } from 'gatsby';
import { Breadcrumb } from '../../interface/breadcrumb.interface';


export default function NewBreadcrumbs({ data }: { data?: Breadcrumb[] | null }) {

  return (
    <>
      {!!data && (
        <ul className={breadcrumbStyle.breadCrumb}>
          {data.map((data: Breadcrumb, index: number) => (
            <li key={`list${index}`} className={breadcrumbStyle.breadCrumb__item}>
              {data?.pageUrl ? <Link to={data?.pageUrl} className={breadcrumbStyle.breadCrumb__itemLink}>{data?.pageTitle || 'N/A'}</Link> : <span className={breadcrumbStyle.breadCrumb__itemLinkLast}>{data?.pageTitle || 'N/A'}</span>}
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
